// extracted by mini-css-extract-plugin
export var arrows = "_66-5";
export var decrementer = "_66-9";
export var disabled = "_66-3";
export var error = "_66-1";
export var hiddenText = "_66-a";
export var incrementer = "_66-8";
export var input = "_66-7";
export var inputWrapper = "_66-0";
export var leadingIcon = "_66-b";
export var readonly = "_66-2";
export var regular = "_66-6";
export var small = "_66-4";